import * as Yup from "yup";

export default Yup.object().shape({
    id: Yup.number(),
    name: Yup.string().nullable().required("Name is required"),
    workerId: Yup.number().nullable().required("AI Number is required"),
    jobTitle: Yup.string().nullable(),
    date: Yup.date().required("Date is required"),
});

